import { withRouter } from 'react-router-dom';
import {
	getMode,
	isReadOnly,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app';
import { getToolBarVisibilityState } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/tool-bar';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createStructuredSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import { connect } from '@atlassian/jira-react-redux';
import mapDispatchToProps from './command';
import type { StateProps, DispatchProps } from './types';
import View from './view';

const mapStateToProps = createStructuredSelector<State, {}, StateProps>({
	mode: getMode,
	readOnly: isReadOnly,
	showToolBar: getToolBarVisibilityState,
});

export default withRouter(
	connect<StateProps, DispatchProps, {}, State>(mapStateToProps, mapDispatchToProps)(View),
);
